<!-- Modals -->
<app-deprecated-modal-form
    #editBenefitsModal
    [form]="editBenefitsForm"
    (save)="onSave()"
    headerText="employees.benefits.editBenefits"
>
    <app-form-benefits
        #editBenefitsForm
        [employeeBenefitPlan]="employeeBenefitPlan"
        [benefitPlans]="benefitPlans"
        [showCertificateNumber]="hasBenefitsPayroll"
    ></app-form-benefits>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #disclaimerDialog
    header="Benefits Plan Disclaimer"
    description="employees.benefits.pleaseNote"
    label="employees.benefits.ok"
    [negative]="false"
>
</app-deprecated-confirmation-dialog>

<div class="ui layout">
    <div class="sidebar">
        <app-profile-card [model]="employee"></app-profile-card>
    </div>
    <div class="content">
        <!-- Benefits Card/Enrollment -->
        <div class="ui segment">
            <app-segment-header
                title="{{ 'employees.benefits.employmentBenefitsPlan' | appTranslate }}"
                (edit)="onShowDisclaimer()"
                [allowEdit]="allowEdit"
            ></app-segment-header>
            <!-- Empty -->
            <div *ngIf="!employeeBenefitPlan?.id" class="empty">
                <img src="/assets/illustrations/benefits.png" />
                <h2 class="ui centered header">
                    {{ 'employees.benefits.noBenefitsHaveBeenAssignedToThisEmployee' | appTranslate }}
                    <div class="sub header">
                        <a [routerLink]="['/benefits']" style="margin-top: 1em; margin-bottom: 2em">{{
                            'employees.benefits.assignPlan' | appTranslate
                        }}</a>
                    </div>
                </h2>
            </div>
            <div *ngIf="employeeBenefitPlan?.benefitPlan" class="flex middle start">
                <div class="inner flex start middle">
                    <app-benefits-card
                        [employee]="employee"
                        [benefits]="employeeBenefitPlan"
                        *ngIf="shouldShowCard"
                    ></app-benefits-card>
                    <div class="benefits-header" [ngStyle]="{ margin: shouldShowCard ? '' : '0px' }">
                        <h2 class="ui header">
                            {{ employeeBenefitPlan?.benefitPlan?.benefitProvider?.name || 'No Provider' }}
                        </h2>
                        <p>
                            {{ 'employees.benefits.waitingPeriod' | appTranslate }}
                            {{
                                (employeeBenefitPlan?.isWaitingPeriodWaved
                                    ? 'employees.benefits.waitingPeriodAsNull'
                                    : employeeBenefitPlan?.benefitPlan?.probationPeriodDescription
                                ) | appTranslate
                            }}
                        </p>
                        <p *ngIf="employeeBenefitPlan?.benefitPlan?.fileId">
                            <a (click)="onDownloadPlan(employeeBenefitPlan?.benefitPlan)">{{
                                'employees.benefits.downloadBenefitsBooklet' | appTranslate
                            }}</a>
                        </p>
                        <p *ngIf="employeeBenefitPlan?.benefitPlan?.planUrl">
                            <a target="_blank" [attr.href]="employeeBenefitPlan?.benefitPlan?.planUrl">{{
                                'employees.benefits.viewPlan' | appTranslate
                            }}</a>
                        </p>
                        <p>
                            <a
                                (click)="addPendoTrackingForClickCarrierPortal()"
                                [attr.href]="employeeBenefitPlan?.benefitPlan?.benefitProvider?.portalUrl"
                                target="_blank"
                                >{{ 'employees.benefits.carrierPortal' | appTranslate }}</a
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Benefits -->
        <div *ngFor="let benefit of employeeBenefitPlan?.benefitPlan?.benefits" class="ui segment benefit">
            <app-segment-header [title]="benefit.benefitCategory?.name" [collapsible]="true"></app-segment-header>

            <div class="content">
                <!-- Provider and File -->
                <div class="logo">
                    <img
                        *ngIf="benefit.benefitProvider"
                        class="ui image"
                        [attr.src]="'/assets/img/brands/' + benefit.benefitProvider?.logoUrl"
                    />
                    <span *ngIf="benefit.fileId && !benefit.benefitProvider"
                        ><i class="fa fal fa-3x fa-file"></i><br /><br
                    /></span>
                    <a *ngIf="benefit.fileId" (click)="onDownloadBenefit(employeeBenefitPlan?.benefitPlan, benefit)">{{
                        'employees.benefits.downloadBooklet' | appTranslate
                    }}</a>
                </div>
                <div class="benefit-description">{{ benefit.description }}</div>
                <!-- Benefit Detail Without Type -->
                <div *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'" class="benefit">
                    <ng-container *ngIf="!detail.value[0]?.benefitType">
                        <!-- Coverage Descriptions -->
                        <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                            <div class="benefit-description">{{ coverage.description }}</div>
                        </div>
                        <!-- Coverages -->
                        <div *ngFor="let coverage of detail.value" class="benefit-details">
                            <div class="ui static form">
                                <div *ngIf="coverage.coverage" class="inline field">
                                    <label>{{ 'employees.benefits.coverage' | appTranslate }}</label>
                                    {{ coverage.coverage | i18nNum: '%' }}
                                </div>
                                <div *ngIf="coverage.reimbursement" class="inline field">
                                    <label>{{ 'employees.benefits.reimbursement' | appTranslate }}</label>
                                    {{ coverage.reimbursement | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.deductible" class="inline field">
                                    <label>{{ 'employees.benefits.deductible' | appTranslate }}</label>
                                    {{ coverage.deductible | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.max" class="inline field">
                                    <label>{{ 'employees.benefits.maximum' | appTranslate }}</label>
                                    {{ coverage.max | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.nem" class="inline field">
                                    <label>{{ 'employees.benefits.nonEvidenceMaximum' | appTranslate }}</label>
                                    {{ coverage.nem | i18nNum: '$' }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <!-- Benefit Details With Type -->
                <div *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'" class="benefitWithType">
                    <ng-container *ngIf="detail.value[0]?.benefitType">
                        <h4 class="ui header">{{ detail.value[0].benefitType?.name }}</h4>
                        <!-- Coverage Descriptions -->
                        <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                            <div class="benefit-description">{{ coverage.description }}</div>
                        </div>
                        <!-- Coverages -->
                        <div *ngFor="let coverage of detail.value" class="benefit-details">
                            <div class="ui static form">
                                <div *ngIf="coverage.coverage" class="inline field">
                                    <label>{{ 'employees.benefits.coverage' | appTranslate }}</label>
                                    {{ coverage.coverage | i18nNum: '%' }}
                                </div>
                                <div *ngIf="coverage.reimbursement" class="inline field">
                                    <label>{{ 'employees.benefits.reimbursement' | appTranslate }}</label>
                                    {{ coverage.reimbursement | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.deductible" class="inline field">
                                    <label>{{ 'employees.benefits.deductible' | appTranslate }}</label>
                                    {{ coverage.deductible | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.max" class="inline field">
                                    <label>{{ 'employees.benefits.maximum' | appTranslate }}</label>
                                    {{ coverage.max | i18nNum: '$' }}
                                </div>
                                <div *ngIf="coverage.nem" class="inline field">
                                    <label>{{ 'employees.benefits.nonEvidenceMaximum' | appTranslate }}</label>
                                    {{ coverage.nem | i18nNum: '$' }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</div>
